<script setup lang="ts">

import AdminHeader from '~/components/layout/admin/adminheader.vue';
import AdminSider from '~/components/layout/admin/sider.vue';

useHead({ meta: [{ name: 'robots', content: 'noindex, nofollow' }] })
</script>

<template>
  <div class="admin-wrap">
    <a-layout>
      <AdminHeader />
      <a-layout>
        <AdminSider />
        <a-layout>
          <a-layout-content class="admin-content-wrap">
            <NuxtPage />
          </a-layout-content>
        </a-layout>
      </a-layout>
    </a-layout>


  </div>
</template>

<style scoped lang="scss">

</style>